import { Box } from "@mantine/core";

interface SystemEmailPreviewFrameProps {
  html: string;
  title: string;
}

export function SystemEmailPreviewFrame({
  html,
  title,
}: SystemEmailPreviewFrameProps) {
  return (
    <Box
      component="iframe"
      srcDoc={html}
      sandbox=""
      title={title}
      w="100%"
      h="70vh"
      style={(theme) => ({
        border: `1px solid ${theme.colors.gray[3]}`,
        borderRadius: theme.radius.md,
      })}
    />
  );
}
